import { render, staticRenderFns } from "./ListCargaTransfolhaView.vue?vue&type=template&id=9a23663a&"
import script from "./ListCargaTransfolhaView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaTransfolhaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports